<template>
    <nav v-if="menu" :class="['fixed top-0 left-0 w-full flex flex-wrap justify-between m-0 pointer-events-auto', {'bg-slate-700 sticky top-0 left-0': isTouchDevice}]" @mouseover="mouseOver" @mouseleave="mouseLeft">
        <div class="w-1/4">
            <Link href="/"><h1 :class="['navhead w-48 py-2  text-slate-100 text-xl font-light px-3 text-center', !mousing && hideNav ? 'opacity-100': 'opacity-100', {'text-backdrop': windowSize.w >= 768}]">Valerie Hird</h1></Link>
        </div>
        <div class="w-l/4 md:w-3/4 nav flex justify-end pointer-events-auto">
            <ul :class="['navhead font-sans font-thin text-backdrop max-w-fit text-white text-base justify-end px-0 sm:px-2 py-0 z-10', {'absolute top-12 right-0 w-full': isTouchDevice}, {'overflow-y-scroll !w-full opacity-100 scale-x-100': mobileMenuOpen && isTouchDevice}, {'block opacity-0 scale-x-0': !mobileMenuOpen && isTouchDevice}, 'w-auto md:flex ']">
                <li v-if="auth?.user?.id" class="py-3 px-2 link"><Link href="/admin/dashboard" class="text-yellow-200">Dashboard</Link></li>
                <li v-if="auth?.user?.id" class="py-3 px-2 link"><Link href="/admin/logout" class="text-yellow-200">Log Out</Link></li>
                <li v-for="m in menu" :class="['py-3 px-2 link', {'active-link': isActiveLink(m.slug)}, {'has-kids': m.menu_children.length > 0}]" :key="m.id">
                    <Link v-if="auth?.user?.id" :href="`/admin/admin-page/${m.id}`" class="w-full"><vue-feather type="edit" size="14px" class="ml-1" /></Link>
                    <Link v-if="m.menu_children.length == 0" :href="`/${m.slug}`" >{{ m.menu_title}}</Link>

                    <template v-else>
                        <Link v-if="!isTouchDevice" :href="`/${m.slug}/${m.menu_children[0].slug}`" >{{ m.menu_title}}</Link>
                        <a v-else href="javascript:" >{{ m.menu_title}}</a>
                     </template>
                    <ul :ref="`nav-${m.id}`" v-if="m.menu_children.length > 0" :class="['p-0', {' text-backdrop': !isTouchDevice}, {'children': !isTouchDevice}]">
                        <li v-for="c in m.menu_children" :key="c.id" :class="['p-1 pl-4', isActiveLink(c.slug)]">
                            <Link :href="`/${m.slug}/${c.slug}`" @click="mouseOver">{{ c.menu_title}}</Link>
                            <Link v-if="auth?.user?.id" :href="`/admin/admin-page/${c.id}`" @click="mouseOver"><vue-feather type="edit" size="14px" class="ml-1" /></Link>
                        </li>
                    </ul>
                </li>
            </ul>
            <div v-if="isTouchDevice || windowSize.w < 768" class="mr-4 absolute top-0 right-0 ">
                <button aria-label="Open Mobile Menu" class="p-2 z-[1400] text-slate-100" @click="mobileMenuOpen=!mobileMenuOpen">
                    <vue-feather type="menu" size="26px" :class="{'transition-transform rotate-90': mobileMenuOpen}" />
                </button>
            </div>
        </div>
    </nav>
</template>

<script>
import { generalStore } from '@/stores/generalStore'
import { mapActions, mapState, mapWritableState } from 'pinia';
import { Link } from '@inertiajs/vue3'
import { api } from '@/api.js'
import dayjs from 'dayjs'

export default {
   name: "NavigationComponent",
   props: ['auth'],
   components: { Link },
   computed: {
        ...mapWritableState(generalStore, ['mouseHideOverride', 'interval', 'mousing', 'windowSize', 'isTouchDevice']),
        ...mapState(generalStore, ['count', 'hideNav']),
        isMobile() {
            return this.windowSize?.w < 768 ? true : false;
        }
   },
   watch: {
        $page(n) {
            this.mobileMenuOpen=false;
        }
   },
   data() {
       return {
            menu: [],
            showKids: null,
            mobileMenuOpen: false
       }
   },
   mounted() {
        this.getMenu();
        this.addXmas();
        // console.log(api.get());
   },
   methods: {
        ...mapActions(generalStore, ['clearTimer', 'startTimeToFade']),
        getMenu() {
            api.get('menu')
            .then(d => {
                this.menu=d.data;
            })
        },
        isActiveLink(slug) {
            let parts=this.$page?.url?.split("/");
            return parts[1] == slug || parts[2] == slug ? 'active' : ''
        },
        mouseOver() {
            this.mouseHideOverride=true;
        },
        mouseLeft() {
            this.mouseHideOverride=false;
            this.startTimeToFade();
        },
        addXmas() {
            let month=dayjs().format('MMMM');
            if(['November', 'December'].includes(month)) {
                this.links.push(
                {
                    icon: 'christmas_tree.png',
                    class: 'xmas',
                    link: {name: 'xmas'},
                    label: 'Christmas cards'
                }
                );
            }
        },
        // navClicked(m) {
        //     const select=this.$refs[`nav-${m.id}`];

        //     if(select[0].classList.contains('on')){
        //         select[0].classList.remove('on');
        //     }else{
        //         select[0].classList.add('on');
        //     }
        //     console.log(select);
        // }
   }
}
</script>
<style lang="postcss">
nav {
    transition: all .1 cubic-bezier(0.215, 0.610, 0.355, 1);
    @apply origin-top;
}
.navhead {
    transition: all .2s cubic-bezier(0.215, 0.610, 0.355, 1);
}
nav li.link {
    position: relative;
}
nav li.link.active-link > a {
    @apply text-yellow-200;
}

nav li.link.has-kids .children {
    transition: all .25s cubic-bezier(0.23, 1, 0.320, 1);
    width: 230px;
    display: none;
}
nav li.link.has-kids:hover ul.children{
    display: block;
    position: absolute !important;
    margin-top: 48px;
    margin-left: -8px;
    top: 0;
    left: 0;
}

</style>
